import DteDocumentsTable from "./components/DteDocumentsTable";

const Tables = () => {
  return (
    <div className="mt-3">
      <DteDocumentsTable />
    </div>
  );
};

export default Tables;
